import { useState, useEffect } from 'react'
import { Program } from '../types'
import { fetchOtherSchedules } from '../utils/program'

export function useProgramOtherSchedules(programId: string | undefined) {
  const [data, setData] = useState<Program[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        if (programId) {
          const channels = await fetchOtherSchedules(programId!)
          setData(channels)
        }
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    if (programId) load()
    else {
      setData(null)
      setIsLoading(false)
      setError(null)
    }
  }, [programId])

  return { data, isLoading, error }
}
